import { getPlaylistTagsByPlaylistId } from '@disco/state-management/selectors/playlists'

import React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { Playlist, PlaylistTag } from 'types/playlist'
import PlaylistTagsList from 'components/common/playlist-tags-list'
type Props = {
  playlist: Playlist
  onTagAdd: (...args: Array<any>) => any
  onTagRemove: (...args: Array<any>) => any
}

const PlaylistPaneHeader = ({
  playlist,
  onTagAdd,
  onTagRemove,
}: Props): React.ReactNode => {
  const playlistTags: Partial<PlaylistTag>[] = useSelector(state =>
    getPlaylistTagsByPlaylistId(state, {
      id: playlist.playlist_id,
    }),
  )
  const isEmpty = playlistTags.length === 0
  if (isEmpty && playlist.read_only) return null
  return (
    <div className="ExplorerPane_Header">
      <PlaylistTagsList
        playlist={playlist}
        tags={playlistTags ?? []}
        onTagAdd={onTagAdd}
        onTagRemove={onTagRemove}
      />
    </div>
  )
}

export default PlaylistPaneHeader
